import React, { useMemo } from 'react';
import { View } from 'react-native';

import { useUserContext } from '../../../common/utils';
import { getProductHealthComplianceLocalValue } from '../../../common/utils/products/healthCompliance';
import Text from '../../components/text/Text';
import { useThemedStyles } from '../../hooks/useThemedStyles';

// Healthy Choices letter in a coloured circle (Green / Amber / Red, NSW
// Everyday / Occasional, n/a).
const ProductHealthCompliance = ({
	product,
}) => {
	const { tenant } = useUserContext();
	const styles = useThemedStyles(createStyles);

	const healthComplianceValue = useMemo(
		() => getProductHealthComplianceLocalValue(product, tenant),
		[product, tenant],
	);

	if (!healthComplianceValue) {
		return null;
	}

	const resolvedStyle = styles[`healthCompliance${healthComplianceValue}`] || styles.healthComplianceNA;

	return (
		<View
			style={[styles.healthCompliance, resolvedStyle]}
			accessible={true}
			accessibilityLabel={`Healthy Choices rating ${healthComplianceValue}`}
		>
			<Text style={[styles.healthComplianceText, healthComplianceValue === 'Amber' && styles.healthComplianceTextAmber]}>
				{healthComplianceValue === 'n/a' ? 'n/a' : healthComplianceValue[0]}
			</Text>
		</View>
	);
};

const createStyles = ({ ui: { colors, type, radius } }) => ({
	healthCompliance: {
		minWidth: 22,
		height: 22,
		paddingHorizontal: 4,
		borderRadius: radius.pill,
		alignItems: 'center',
		justifyContent: 'center',
	},
	healthComplianceGreen: {
		backgroundColor: colors.success,
	},
	healthComplianceEveryday: {
		backgroundColor: colors.success,
	},
	healthComplianceAmber: {
		backgroundColor: colors.amberSolid,
	},
	healthComplianceRed: {
		backgroundColor: colors.danger,
	},
	healthComplianceOccasional: {
		backgroundColor: colors.textSecondary,
	},
	healthComplianceNA: {
		backgroundColor: colors.accent,
	},
	healthComplianceText: {
		...type.label,
		color: colors.canvas,
	},
	healthComplianceTextAmber: {
		color: colors.onAmberSolid,
	},
});

export default ProductHealthCompliance;
